import css from './frame.scss';

const Frame = (props) => {
    return (
        <div className={`${css.root} ${props.right?css.right:''} ${props.left?css.left:''} ${props.blue?css.blue:''} ${props.white?css.white:''}`}>
            {props.children}
        </div>
    )
}

export default Frame;